// Environment configuration for API settings
export const API_CONFIG = {
    // API Base URL - defaults to production backend
    BASE_URL: process.env.REACT_APP_API_URL || 'https://english-guru-backend.onrender.com',
    
    // API Key - defaults to development key
    API_KEY: process.env.REACT_APP_API_KEY || 'development-api-key',
    
    // Environment detection
    IS_PRODUCTION: process.env.NODE_ENV === 'production',
    IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
    
    // API endpoints
    ENDPOINTS: {
        USER: '/api/user',
        USER_DATA: (userId: string) => `/api/user/${userId}`,
        USER_LANGUAGE: (userId: string) => `/api/user/${userId}/language`,
    },
    
    // Request configuration
    REQUEST_CONFIG: {
        TIMEOUT: 15000,
        RETRY_ATTEMPTS: 3,
        RETRY_DELAY: 1000,
    },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
    return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get request headers
export const getRequestHeaders = (): Record<string, string> => {
    return {
        'Content-Type': 'application/json',
        'X-API-Key': API_CONFIG.API_KEY,
        'X-Requested-With': 'XMLHttpRequest',
    };
};

// Helper function to make API requests
export const makeApiRequest = async (
    endpoint: string, 
    options: RequestInit = {}
): Promise<Response> => {
    const url = getApiUrl(endpoint);
    const headers = getRequestHeaders();
    
    const config: RequestInit = {
        ...options,
        headers: {
            ...headers,
            ...options.headers,
        },
    };
    
    console.log('Making API request:', {
        url,
        method: config.method || 'GET',
        hasApiKey: !!headers['X-API-Key'],
    });
    
    return fetch(url, config);
}; 